import { Injectable } from '@angular/core'
import { BaseService } from '../base-service/base.service'
import { UAA } from '../constants/microservice.name.constants'
import { map } from 'rxjs/operators'

@Injectable({
	providedIn: 'root'
})
export class AuthServiceService extends BaseService {
	override microserviceName = UAA

	refreshToken() {
		return super.getService('refresh')
	}

	getOneExtraField(userId: string) {
		return super.getService('user/get-one-extra-field', {userId}).pipe(map(res => res.body as IUserExtraFields))
	}
}

interface IUserExtraFields {
	fatherName: string
	birthDate: string
	firstNameEn: string
	lastNameEn: string
	maritalStatus: 'MARRIED' | 'SINGLE'
	numberOfChildren?: number
	ssn?: string
	nationality: string
	jobDescription: string
	howToFindUs: string
}
